import { render, staticRenderFns } from "./suppliesManage.vue?vue&type=template&id=d56c28ee&"
import script from "./suppliesManage.vue?vue&type=script&lang=js&"
export * from "./suppliesManage.vue?vue&type=script&lang=js&"
import style0 from "./suppliesManage.vue?vue&type=style&index=0&id=d56c28ee&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports